/*global MatchSocket*/

var DesktopMatch = function() {

    return {
        proHistoryScrollTop: 0,
        init: function(mid, autorefresh) {
            DesktopMatch.mid = mid;
            DesktopMatch.autorefresh = autorefresh;
            Vote.init();
            DesktopMatch.init_h2h_handler();
            MatchStats.registerBtnHandlers();
            if (DesktopMatch.autorefresh) {
                setTimeout(DesktopMatch.matchRefreshLoop, 20 * 1000);
                MatchSocket.init(mid);
            }
            Generic.init_popovers();
            var hash = window.location.hash;
            if (hash) {
                $('.nav-tabs a[href="' + hash + '"]').tab('show');
                window.scrollTo(0, 0);
                Generic.change_hash_without_scroll(hash);
            }
            $('.ii__matchpage_tab').click(function(e) {
                $(this).tab('show');
                var scrollto = $('.tab-content').offset().top - 112;
                if ($(document).scrollTop() >= scrollto) {
                    $(document).scrollTop(scrollto);
                }
                Generic.change_hash_without_scroll(this.hash);
                var tabname = $(this).data('tabname');
                if (!tabname) {
                    return;
                }
                ActionTracker.record('matchpage-tab-' + tabname + '-desktop');
            });
            $('#game_teams_history').on('scroll', DesktopMatch.matchHistoryScroll);
            Star.initMatchStarHandler();
        },
        matchHistoryScroll: function() {
            DesktopMatch.proHistoryScrollTop = this.scrollTop;
        },
        position_h2h_handler: function() {
            var p = $('.ii__h2h_list_toggler').position();
            if (typeof p === 'undefined') {
                p = {top: 325, left: 800};
            }
            var rs = $('#res_single').position();
            if (typeof rs === 'undefined') {
                rs = {top: 180, left: 15};
            }
            var left = p.left - $('#h2h_list').width() / 2 + $('.ii__h2h_list_toggler').width() / 2;
            if (left + $('#h2h_list').width() > rs.left + $('#res_single').width()) {
                // reset left position if it goes over the edge of the screen
                left = rs.left + $('#res_single').width() - $('#h2h_list').width() + 34;
            }
            $('#h2h_list').css('top', p.top + 13);
            $('#h2h_list').css('left', left);
        },
        init_h2h_handler: function() {
            $(window).on('resize', function() {
                DesktopMatch.position_h2h_handler();
            });
            DesktopMatch.position_h2h_handler();
            $('.ii__h2h_list_toggler').click(function() {
                $('#h2h_list').toggle();
                if ($('#h2h_list').is(':visible')) {
                    DesktopMatch.position_h2h_handler();
                    $(this).find('i.icon').removeClass('fa-caret-down').addClass('fa-caret-up');
                } else {
                    $(this).find('i.icon').removeClass('fa-caret-up').addClass('fa-caret-down');
                }
            });
        },
        matchRefresh: function() {
            var h2h_list_visible = $('#game_teams_history').is(':visible');
            DesktopMatch.tabLoad('events', DesktopMatch.mid);
            return Ajax.getMatchHead(DesktopMatch.mid, function(data) {
                $('#res_single').html(data.html);
                MatchSocket.reapplySocketUpdates();
                Generic.init_popovers();
                Star.initMatchStarHandler();
                DesktopMatch.init_h2h_handler();
                Generic.updateTimes();
                if (h2h_list_visible) {
                    $('.ii__match-teams-history').click();
                    $('#game_teams_history').scrollTop(DesktopMatch.proHistoryScrollTop);
                    $('#game_teams_history').on('scroll', DesktopMatch.matchHistoryScroll);
                }
                Commentaries.load(DesktopMatch.mid);
                MatchStats.refresh(DesktopMatch.mid);
            });
        },
        matchRefreshLoop: function() {
            DesktopMatch.matchRefresh().finally(function() {
                setTimeout(DesktopMatch.matchRefreshLoop, 20 * 1000);
            });
        },
        saveOddsCompany: function(odds_company_id) {
            Generic.showProgressLoader();
            Ajax.savePrefOddsCompany(odds_company_id, () => {
                DesktopMatch.tabLoad(
                    'votes',
                    DesktopMatch.mid,
                    Vote.init
                );
                Generic.hideProgressLoader();
            });
        },
        tabLoad: function(tab, mid, callback = null) {
            Ajax.getMatchTab(mid, tab, function(data) {
                $('#con_' + tab).html(data.html);
                if (tab == 'comments') {
                    Generic.init_popovers();
                    Generic.init_gifemoji_enabled_input();
                    UserMention.init();
                }
                if (!Generic.loggedin && tab == 'votes') {
                    Generic.hideCookieVotes();
                }
                if (callback != null) {
                    callback();
                }
            });
        }
    };
}();
